// src/AdminPortal/activeSessionsApi.js
import axios from 'axios';
import config from './config';

const API_BASE_URL = `${config.API_BASE_URL}`;

export async function fetchActiveSessionsCount() {
  try {
    const response = await axios.get(`${API_BASE_URL}/ActiveSessions/count`);
    if (response.data && response.data.Success && typeof response.data.ActiveSessionsCount === 'number') {
      return response.data.ActiveSessionsCount;
    }
    return 0;
  } catch (error) {
    console.error('Failed to fetch active sessions count:', error);
    return 0;
  }
}